import Raty from 'raty-js';

class Stars {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-stars="scope"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, element) => {
			let $element = $(element);
			let settings = Object.assign({
				readOnly: true,
				starOn: '/image/raty/star-on.svg',
				starOff: '/image/raty/star-off.svg',
				starHalf: '/image/raty/star-half.svg',
			}, $element.data());
			let raty = new Raty(element, settings);
			raty.init();
		});
	}
}

export default Stars;